import { Navigate } from "react-router-dom";

interface Props {
  element: React.ReactNode;
  hasGestorURL: boolean;
}

export const ProtectedRouteGestor = ({ element, hasGestorURL }: Props) => {
  if (!hasGestorURL) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{element}</>;
};
